<template>
	<div class="home_page">
		<div class="header flex align-center justify-between">
			<img class="logo" @click="toHome" :src="imgBaseUrl+detail.top_logo" alt="">
			<div class="right flex align-center">
				<div class="item" :class="topMenuActive == 0 ? 'active' : ''" @click="toUser">My Bookings</div>
				<div class="item" :class="topMenuActive == 1 ? 'active' : ''" @click.stop="getMessage">
					<div>Notifications</div>
					<div class="box" v-if="readNum>0"></div>
				</div>
				<div class="item" :class="topMenuActive == 2 ? 'active' : ''">
					<img @click="toCart" src="../../assets/images/icon/cart.png" alt="">
				</div>
				<div class="item"  v-if="!userInfo.id">
					<div  @click="toSign">Log in</div>
					<div @click="toRegister">Sign up</div>
				</div>
				<div class="item"  v-else @click="toUser">
					<div>Hi {{userInfo.first_name}}</div>
				</div>
				<div class="message_list" v-if="showMessage" @click.stop="">
					<ul class="list">
						<li class="message_item" v-for="(item,index) in messageList" :key="index">
							<div class="title">{{item.title}}</div>
							<!-- <div class="message_content">{{item.content}}</div> -->
							<div class="bottom flex align-center justify-between">
								<div class="time">{{item.createtime}}</div>
								<div class="more" @click="toMessage(item.id)">Read more>></div>
							</div>
							<div class="box" v-if="!item.is_read"></div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="home_menu">
			<div class="main flex align-center justify-between">
				<div class="item" 
				@click="switchMenu(index)"
				:class="menuActive == index ? 'active' : ''"
				v-for="(item,index) in menuList" :key="index"
				>{{item}}</div>
			</div>
		</div>
		<div class="home_content">
			
			<router-view @changeMenu="changeMenu"></router-view>
			<div class="kefu">
				<el-popover
				  placement="right"
				  width="750"
				  :ref="popover"
				  trigger="click">
				  <div class="kefu_content">
					  <div class="header">
						  <div class="title">H﻿e﻿l﻿p﻿ ﻿C﻿e﻿n﻿t﻿r﻿e﻿ </div>
						  <!-- <img class="close" slot="reference" @click="closePopover" src="../../../assets/images/icon/close.png" alt=""> -->
					  </div>
					  <div class="problem_content flex">
						  <div class="photo">
							  <img src="../../assets/images/icon/photo.png" alt="">
						  </div>
						  <div class="list">
							  <div class="item weight" @click="toHelp">Frequently Asked Questions</div>
							  <!-- <div class="item flex align-center justify-between" v-for="(item,index) in problemList" :key="index">
								  <div class="name">{{item.title}}</div>
								  <img src="../../assets/images/icon/right.png" alt="">
							  </div> -->
							<!--  <div class="item flex align-center justify-between">
								  <div class="name">会员如何使用？</div>
								  <img src="../../../assets/images/icon/right.png" alt="">
							  </div> -->
						  </div>
					  </div>
					  <div class="fileInfo_box">
						  <div class="info_item">
						  	<input type="text" placeholder="Subject" v-model="title">
						  </div>
							<div class="info_item">
								<input type="text" placeholder="Full name" v-model="name">
							</div>
							<div class="info_item">
								<input type="text" placeholder="Your email" v-model="contact">
							</div>
							<div class="info_item">
								<textarea placeholder="Please use this box to give us some information about your query" v-model="content"></textarea>
							</div>
							<div class="submit" @click="feedback">submit</div>
					  </div>
					  
				  </div>
				 <img slot="reference" src="../../assets/images/icon/kefu.png" alt="">
				</el-popover>
				
			</div>
		</div>
		<footer>
			<div class="footer_main flex align-center justify-between">
				<img class="logo" :src="imgBaseUrl + detail.bottom_logo" alt="">
				<div class="agree_list flex align-center">
					<!-- <div class="item" @click="toHelp">Needs to be translated </div> -->
					<div class="item" @click="toHelp">FAQ's</div>
					<div class="item" @click="getTerm(1)">Terms & Conditions</div>
					<div class="item" @click="getTerm(2)">Privacy Policy</div>
				</div>
				<div class="login_type flex align-center">
					<img @click="toUrl(0)" src="../../assets/images/icon/twitter.png" alt="">
					<img @click="toUrl(1)" src="../../assets/images/icon/face.png" alt="">
					<img @click="toUrl(2)" src="../../assets/images/icon/ins.png" alt="">
				</div>
			</div>
			
		</footer>
		<div class="model" v-if="selectModel" @click="selectModel = false">
			<div class="model_content" @click.stop="">
				<div class="detail" v-if="showType == 1" v-html="detail.privacy_policy"></div>
				<div class="detail" v-else v-html="detail.privacy_agreement"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				menuList:['Home','About','Classes','Events & Camps','Class Packs','Parental Support','Parties','Bespoke','Shop','Contact'],
				menuActive:0,
				topMenuActive:-1,
				showMessage:false,
				detail:{},
				messageList:[],
				selectModel:false,
				showType:0,
				problemList:[],
				name:'',
				content:'',
				contact:'',
				title:'',
				userInfo:{},
				readNum:0,
			}
		},
		watch:{
			$route(to,from){
				console.log(to.path)
				if(to.path == '/home/classPack'){
					this.menuActive = 3
				}
			}
		},
		created(){
			this.getProblemList()
			var token = localStorage.getItem('token');
			if(token){
				this.getUser()
			}
			document.addEventListener("click", this.closeMessage);
			this.getReadNum()
			setInterval(()=>{
				this.getReadNum()
			},5000)
			// if(!token){
			// 	this.$router.push('/login')
			// }
			this.getSystem()
			var href = window.location.hash;
			console.log(href)
			if(href.search('/home/home') != -1){
				this.topMenuActive = -1;
				this.menuActive = 0
			}else if(href.search('/home/about') != -1){
				this.topMenuActive = -1;
				this.menuActive = 1
			}else if(href.search('/home/classes') != -1){
				this.topMenuActive = -1;
				this.menuActive = 2
			}else if(href.search('/home/classPack') != -1){
				this.topMenuActive = -1;
				this.menuActive = 4;
			}else if(href.search('/home/parent') != -1){
				this.topMenuActive = -1;
				this.menuActive = 5
			}else if(href.search('/home/party') != -1){
				this.topMenuActive = -1;
				this.menuActive = 6
			}else if(href.search('/home/event') != -1){
				this.topMenuActive = -1;
				this.menuActive = 3
			}else if(href.search('/home/mall') != -1){
				this.topMenuActive = -1;
				this.menuActive = 8
			}else if(href.search('/home/contact') != -1){
				this.topMenuActive = -1;
				this.menuActive = 9
			}else if(href.search('/home/userInfo') != -1){
				this.topMenuActive = 0;
				this.menuActive =-1
			}else if(href.search('/home/cart') != -1){
				this.topMenuActive = 2;
				this.menuActive =-1
			}
		},
		methods:{
			getSystem(){
				this.$api.post('common/getsystem',{type:'sys'},res=>{
					if(res.code == 1){
						this.detail = res.data;
					}
				})
			},
			getReadNum(){
				this.$api.post('news/getReadNum',{},res=>{
					if(res.code == 1){
						this.readNum = res.data.num;
					}
				})
			},
			getUser(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.userInfo = res.data;
					}
				})
			},
			feedback(){
				var params = {
					content:this.content,
					contact:this.contact,
					name:this.name,
					title:this.title
				}
				this.$api.post('common/feedback',params,res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Successful'
						})
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			getProblemList(){
				this.$api.post('Article/getArticlesList',{},res=>{
					if(res.code == 1){
						this.problemList = res.data;
					}
				})
			},
			getTerm(type){
				this.showType = type;
				this.selectModel = true;
			},
			toHome(){
				this.menuActive = 0;
				this.topMenuActive = -1
				this.$router.push('/home/home')
			},
			getMessageList(){
				this.$api.post('news/getlist',{},res=>{
					if(res.code == 1){
						this.showMessage = true;
						this.messageList = res.data;
					}
				},err=>{
					if(err.code == '401'){
						localStorage.removeItem('token');
						this.$router.push('/login')
					}
				})
			},
			changeMenu(data){
				this.menuActive = data.type;
				this.topMenuActive = -1;
			},
			toHelp(){
				this.topMenuActive = -1;
				this.menuActive = -1;
				this.$router.push('/home/helpCenter')
			},
			toUrl(type){
				if(type == 0){
					location.href = this.detail.twitter_url
				}else if(type == 1){
					location.href = this.detail.facebook_url
				}else{
					location.href = this.detail.ins_url
				}
			},
			switchMenu(index){
				this.menuActive = index;
				this.topMenuActive = -1;
				if(index == 0){
					this.$router.push('/home/home')
				}else if(index == 1){
					this.$router.push('/home/about')
				}else if(index == 2){
					this.$router.push({path:'/home/classes',query:{date:''}})
					// this.$router.push('/home/classes')
				}else if(index == 4){
					this.$router.push('/home/classPack')
				}else if(index == 5){
					// this.$router.push('/home/parentClass')
					this.$router.push('/home/parent')
				}else if(index == 6){
					this.$router.push('/home/party')
				}else if(index == 3){
					// this.$router.push('/home/events')
					this.$router.push('/home/event')
				}else if(index == 7){
					this.$router.push('/home/bespoke')
				}else if(index == 8){
					this.$router.push('/home/mall')
				}else if(index == 9){
					this.$router.push('/home/contact')
				}
			},
			toCart(){
				var token = localStorage.getItem('token');
				if(!token){
					this.$router.push('/login')
				}else{
					this.menuActive = -1;
					this.topMenuActive = 2;
					this.$router.push({path:'/home/cart',query:{type:0}})
				}
				
			},
			toSign(){
				this.$router.push('/login')
			},
			toRegister(){
				this.$router.push('/register')
			},
			toUser(){
				var token = localStorage.getItem('token');
				if(!token){
					this.$router.push('/login')
				}else{
					this.menuActive = -1;
					this.topMenuActive = 0;
					this.$router.push('/home/userInfo/orderList')
				}
				
			},
			toMessage(id){
				this.showMessage = false
				this.$router.push({path:'/home/messageDetail',query:{id:id}})
			},
			getMessage(){
				var token = localStorage.getItem('token');
				if(token){
					this.menuActive = -1;
					this.topMenuActive = 1;
					this.getMessageList()
				}else{
					this.$router.push('/login')
				}
				
				
			},
			closeMessage(){
				if(this.showMessage){
					this.showMessage = false;
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.home_page{
		min-width: 100%;
		min-height: 100vh;
		background-color: #F7F2EB;
		position: relative;
		padding-bottom: 180px;
		.header{
			width: 1200px;
			height: 152px;
			background: #F7F2EB;
			margin: 0 auto;
			.logo{
				width: 425px;
				height: 87px;
				cursor: pointer;
			}
			.right{
				position: relative;
				.item{
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					margin-right: 80px;
					cursor: pointer;
					position: relative;
					&.active:after{
						content: '';
						width: 65px;
						height: 4px;
						background: #5C707A;
						border-radius: 2px;
						position: absolute;
						left: 50%;
						bottom: -18px;
						transform: translateX(-50%);
					}
					.box{
						width: 10px;
						height: 10px;
						border-radius: 50%;
						background-color: red;
						position: absolute;
						top: 0;
						right: -10px;
					}
				}
				img{
					width: 28px;
					height: 27px;
					cursor: pointer;
				}
				.message_list{
					width: 748px;
					height: 604px;
					background: #F7F2EB;
					box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
					border-radius: 10px;
					position: absolute;
					top: 80px;
					left: 50%;
					transform: translateX(-50%);
					padding: 30px;
					z-index: 999;
					overflow-y: scroll;
					.message_item{
						width: 100%;
						// height: 174px;
						background: #F7F2EB;
						box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
						border-radius: 10px;
						padding: 30px 25px;
						margin-bottom: 20px;
						position: relative;
						.title{
							font-size: 18px;
							font-family: PingFang SC;
							font-weight: bold;
							color: #282E30;
							margin-bottom: 10px;
						}
						.message_content{
							font-size: 16px;
							font-family: PingFang SC;
							font-weight: 400;
							color: #CCCCCC;
							line-height: 36px;
							margin: 20px 0 10px;
						}
						.time{
							font-size: 16px;
							font-family: PingFang SC;
							font-weight: 400;
							color: #CCCCCC;
						}
						.more{
							font-size: 16px;
							font-family: PingFang SC;
							font-weight: 400;
							color: #5C707A;
							cursor: pointer;
						}
						.box{
							width: 10px;
							height: 10px;
							border-radius: 50%;
							background-color: red;
							position: absolute;
							top: 10px;
							right: 10px;
						}
					}
				}
			}
		}
		.home_menu{
			width: 100%;
			height: 88px;
			background: #5C707A;
			.main{
				width: 1200px;
				height: 100%;
				margin: 0 auto;
				.item{
					height: 100%;
					line-height: 88px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #F7F2EB;
					cursor: pointer;
					position: relative;
					&.active:after{
						content: '';
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translateX(-50%);
						width: 65px;
						height: 4px;
						background: #FFFFFF;
						border-radius: 2px;
					}
				}
			}
		}
		footer{
			width: 100%;
			height: 150px;
			background: #5C707A;
			position: absolute;
			bottom: 0;
			left: 0;
			.footer_main{
				width: 1300px;
				height: 100%;
				margin: 0 auto;
				.logo{
					width: 269px;
					height: 54px;
				}
				.agree_list{
					.item{
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #F7F2EB;
						margin-right: 30px;
						cursor: pointer;
					}
				}
				.login_type{
					img{
						width: 52px;
						height: 52px;
						margin-left: 20px;
						cursor: pointer;
					}
				}
			}
		}
	}
	.model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: rgba(0,0,0,0.2);
		z-index: 99;
		.model_content{
			width: 750px;
			height: 80%;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 30px;
			overflow-y: scroll;
		}
		
	}
	.kefu{
		position: fixed;
		right: 30px;
		bottom: 50%;
		z-index: 999;
		img{
			width: 100px;
			height: 100px;
		}
		
	}
	::v-deep .el-popover{
		padding: 0;
	}
	.kefu_content{
		width: 750px;
		height: 800px;
		overflow-y: scroll;
		.header{
			width: 100%;
			height: 88px;
			background: #5C707A;
			border-radius: 10px;
			position: relative;
			.title{
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #FFFFFF;
				text-align: center;
				line-height: 88px;
			}
			.close{
				width: 29px;
				height: 28px;
				position: absolute;
				right: 30px;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		.problem_content{
			width: 100%;
			padding: 30px 30px 50px;
			background: #F7F2EB;
			.photo{
				width: 79px;
				height: 79px;
				border-radius: 50%;
				overflow: hidden;
				margin-right: 20px;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.list{
				width: 492px;
				background: #F7F2EB;
				box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
				border-radius: 0px 20px 20px 20px;
				padding: 0 30px 30px;
				.item{
					width: 100%;
					height: 67px;
					line-height: 67px;
					font-size: 18px;
					font-family: PingFang SC;
					font-weight: 400;
					color: #282E30;
					border-bottom: 1px solid rgba(40,46,48,0.2);
					&.weight{
						font-size: 22px;
						font-weight: bold;
						color: #282E30;
					}
					img{
						width: 15px;
						height: 27px;
					}
				}
			}
			
		}
		.fileInfo_box{
			width: 100%;
			background: #F7F2EB;
			box-shadow: 0px -17px 18px 0px rgba(35,24,21,0.0400);
			border-radius: 10px;
			padding: 50px 30px;
			.info_item{
				margin-bottom: 30px;
				input{
					width: 100%;
					height: 80px;
					background: #F7F2EB;
					border: 1px solid #CCCCCC;
					border-radius: 20px;
					padding: 0 30px;
					line-height: 80px;
					font-size: 22px;
					font-family: PingFangSC;
					font-weight: 500;
					color: #999999;
					line-height: 80px;
				}
				textarea{
					width: 100%;
					height: 200px;
					background: #F7F2EB;
					border: 1px solid #CCCCCC;
					border-radius: 20px;
					padding: 27px 30px;
					font-size: 22px;
					font-family: PingFangSC;
					font-weight: 500;
					color: #999999;
					line-height: 30px;
					outline: none;
				}
			}
		}
		.submit{
			width: 500px;
			height: 88px;
			background: #5C707A;
			box-shadow: 0px 2px 7px 0px rgba(0,0,0,0.2000);
			border-radius: 20px;
			margin:0 auto;
			font-size: 22px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #F7F2EB;
			line-height: 88px;
			text-align: center;
			cursor: pointer;
		}
	}
</style>